import { createContext } from "react";

const ButtonsContext = createContext("")

export default ButtonsContext;